import { render, staticRenderFns } from "./myDialog5.vue?vue&type=template&id=2cb8e924&scoped=true&"
import script from "./myDialog5.vue?vue&type=script&lang=js&"
export * from "./myDialog5.vue?vue&type=script&lang=js&"
import style0 from "./myDialog5.vue?vue&type=style&index=0&id=2cb8e924&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb8e924",
  null
  
)

export default component.exports